<template>
  <div :class="hostClass">
    <p v-if="!unreadNotifications.length" :class="$style.noNotifications">
      You have no unread notifications
    </p>
    <component
      v-for="notification in unreadNotifications"
      :key="notification.id"
      :is="typeToComponent(notification)"
      :notification="notification"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Sentry from "@sentry/browser";
import ActivityCommented from "./notifications/activity-commented";
import ActivityAddedToPlaylist from "./notifications/activity-added-to-playlist";
import ActivityLiked from "./notifications/activity-liked";
import ActivityLiveCoached from "./notifications/activity-live-coached";
import ActivityMentioned from "./notifications/activity-mentioned";
import ActivityNotLogged from "./notifications/activity-not-logged";
import ActivityScored from "./notifications/activity-scored";
import ActivityShared from "./notifications/activity-shared";
import OpportunityMentioned from "./notifications/opportunity-mentioned";
import OpportunityCommented from "./notifications/opportunity-commented";
import CoachRequested from "./notifications/coach-requested";
import NotifyActivityContributor from "./notifications/notify-activity-contributor";
import TrialEnding from "./notifications/trial-ending";

const notificationComponents = new Map([
  ["Jiminny\\Notifications\\ActivityCommented", ActivityCommented],
  ["Jiminny\\Notifications\\Playlists\\ActivityAdded", ActivityAddedToPlaylist],
  ["Jiminny\\Notifications\\ActivityLiked", ActivityLiked],
  ["Jiminny\\Notifications\\ActivityLiveCoached", ActivityLiveCoached],
  ["Jiminny\\Notifications\\ActivityMentioned", ActivityMentioned],
  ["Jiminny\\Notifications\\ActivityNotLogged", ActivityNotLogged],
  ["Jiminny\\Notifications\\ActivityScored", ActivityScored],
  ["Jiminny\\Notifications\\ActivityShared", ActivityShared],
  ["Jiminny\\Notifications\\OpportunityMentioned", OpportunityMentioned],
  ["Jiminny\\Notifications\\OpportunityCommented", OpportunityCommented],
  ["Jiminny\\Notifications\\CoachRequested", CoachRequested],
  [
    "Jiminny\\Notifications\\Activities\\NotifyContributor",
    NotifyActivityContributor
  ],
  ["Jiminny\\Notifications\\TrialEnding", TrialEnding]
]);

export default {
  components: {
    ActivityCommented,
    ActivityAddedToPlaylist,
    ActivityLiked,
    ActivityLiveCoached,
    ActivityMentioned,
    ActivityNotLogged,
    ActivityScored,
    ActivityShared,
    OpportunityMentioned,
    OpportunityCommented,
    CoachRequested,
    NotifyActivityContributor,
    TrialEnding
  },
  computed: {
    ...mapGetters(["unreadNotifications"]),
    hostClass() {
      return `host-${this.$_notifications_config.hostApp}`;
    }
  },
  methods: {
    typeToComponent(notification) {
      if (notificationComponents.has(notification.type)) {
        return notificationComponents.get(notification.type);
      } else {
        Sentry.captureException(
          `Unknown notification type: ${notification.type}`
        );
      }
    }
  }
};
</script>

<style module lang="less" src="./notifications.less"></style>



// WEBPACK FOOTER //
// notifications.vue?0f14820c